import * as types from './mutation_types';
import {API_ENTRYPOINT} from "../../../config/entrypoint";
import fetch from "../../../utils/fetch";
import {toastError} from "../../../utils/toast";
import {logFrontendError} from "../../../utils/errorLog";
import {Positions} from "../../../utils/positionEnum";

// Presne tech 5 prechodu z vitezstvi nad trenerem (viz FightAction.php's
// checkTrainerFight) - drzeni na bojove obrazovce (viz pokemonFight nize)
// se tyka jen jich, zadny jiny prechod (utek, prohra v lize, Team Rocket
// ambush, vyhra nad divokym pokemonem bez trenera) se nezdrzuje.
const TRAINER_WIN_TYPES = [
  Positions.FIGHT_STADION_TRAINER_WIN,
  Positions.FIGHT_WILD_TRAINER_WIN,
  Positions.MEWTWO_FIGHT_WIN,
  Positions.LEAGUE_OAK,
  Positions.LEAGUE_WIN,
];

const FIGHTING_POSITION_TYPES_FOR_WIN_HOLD = [
  Positions.FIGHT_TRAINER,
  Positions.LEAGUE_FIGHT,
  Positions.MEWTWO_FIGHT,
];

// Sdileny catch pro vsechny journey akce nize - kromě commitu LOADING
// false/ERROR (ten uz odblokuje isLoading-guardovana tlacitka pro dalsi
// pokus) i vizualni toast (uz prelozena hlaska z utils/fetch.js) a log na
// backend, aby chyba jako "Not enough steps" nezmizela beze stopy jen v
// tichem Vuex state.error, ktery dnes nikde nema konzumenta.
function onJourneyError(commit, e) {
  commit(types.JOURNEY_SET_LOADING, false);
  commit(types.JOURNEY_SET_ERROR, e.message);
  toastError(e.message);
  logFrontendError(e.message, e.stack);
}

// Deduplikace soubezne rozjetych GET pozadavku na stejne URL - TopBar.vue
// (globalni shell) a Journey.vue (created() po prichodu na /journey) volaji
// /get-position/{id} nezavisle na sobe ve stejnem okamziku hned po loginu.
// Generické podle URL, funguje i pro dalsi GET volani pres positionPost
// (napr. TopBar.newDay()).
const pendingGetRequests = new Map();

function fetchGetDeduped(url, dispatch) {
  const key = url.toString();
  if (pendingGetRequests.has(key)) {
    return pendingGetRequests.get(key);
  }
  const promise = fetch(url, {method: 'GET', dispatch: dispatch})
    .then((response) => response.json())
    .finally(() => pendingGetRequests.delete(key));
  pendingGetRequests.set(key, promise);
  return promise;
}

export const reset = ({ commit }) => {
  commit(types.JOURNEY_RESET);
};

export const positionPost = ({commit, dispatch, state}, obj) => {
  commit(types.JOURNEY_SET_LOADING, true);

  if ( obj.method.toUpperCase() === 'GET') {
    const previousPosition = state.position;

    return fetchGetDeduped(obj.url, dispatch)
      .then((data) => {
        commit(types.JOURNEY_SET_LOADING, false);
        trySyncFightingPokemonHp(dispatch, data, previousPosition);
        commit(types.JOURNEY_SET_POSITION, data);
        trySetMusic(commit, data);
        trySyncOwnTrainerBalls(dispatch, data);
      })
      .catch((e) => onJourneyError(commit, e));
  }

  const previousPosition = state.position;
  return fetch(obj.url, {method: obj.method, body: JSON.stringify(obj.obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.JOURNEY_SET_LOADING, false);
      trySyncFightingPokemonHp(dispatch, data, previousPosition);
      commit(types.JOURNEY_SET_POSITION, data);
      trySetMusic(commit, data);
      trySyncOwnTrainerBalls(dispatch, data);
    })
    .catch((e) => onJourneyError(commit, e));
};

export const fetchObject = ({commit, dispatch},obj) => {
  commit(types.JOURNEY_SET_LOADING, true);

  if (obj.method === 'GET'){
    return fetch(obj.url, {dispatch: dispatch})
      .then((response) => response.json())
      .then((data) => {
        commit(types.JOURNEY_SET_LOADING, false);
        trySetMusic(commit, data);
        return data;
      })
      .catch((e) => onJourneyError(commit, e));
  }
  // OTHER
  return fetch(obj.url, {method: obj.method, body: JSON.stringify(obj.obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.JOURNEY_SET_LOADING, false);
      return data;
    })
    .catch((e) => onJourneyError(commit, e));
};

export const findStonePokemons = ({commit, dispatch},obj) => {
  commit(types.JOURNEY_SET_LOADING, true);

  const url = new URL("/api/find-stolen-pokemons/"+obj.trainerId, API_ENTRYPOINT);
    return fetch(url, {dispatch: dispatch})
      .then((response) => response.json())
      .then((data) => {
        commit(types.JOURNEY_SET_LOADING, false);
        obj.position.days = data.days;
        // stolenPokemonsCount se jinak nikde neaktualizuje (endpoint vraci jen
        // {message, pokemons, days, missing}) - bez tohohle by dlazdice
        // "Officer Jenny" (CityNext.vue, hasStolenPokemons) zustala videt i po
        // nalezeni vsech pokemonu.
        obj.position.trainer.stolenPokemonsCount = data.missing;
        // havingPokemonsCount (pouziva i league registrace gate,
        // RegisterLeagueDialog.vue) se taky neaktualizuje samo - kazdy
        // nalezeny pokemon uz neni stolen, takze se ma pripocitat.
        obj.position.trainer.havingPokemonsCount = obj.position.trainer.havingPokemonsCount + data.pokemons.length;
        commit(types.JOURNEY_SET_POSITION, obj.position);
        return data;
      })
      .catch((e) => onJourneyError(commit, e));
};

export const loadItems = ({commit, dispatch}) => {
  commit(types.JOURNEY_SET_LOADING, true);
  const url = new URL("api/trainers", API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.JOURNEY_SET_LOADING, false);
      commit(types.JOURNEY_SET_ITEMS, data['member']);
    })
    .catch((e) => onJourneyError(commit, e));
};

export const loadPosition = ({commit, dispatch}, id) => {
  commit(types.JOURNEY_SET_LOADING, true);
  const url = new URL('api/get-position/'+id, API_ENTRYPOINT);

  // fetch.js si token ze sessionStorage priloží samo (viz utils/fetch.js);
  // sdileny fetchGetDeduped() navic deduplikuje soubezne volani stejneho URL,
  // takze TopBar.vue (positionPost) a Journey.vue (loadPosition) po loginu
  // neposilaji dva stejne pozadavky zaroven.
  return fetchGetDeduped(url, dispatch)
    .then((data) => {
      commit(types.JOURNEY_SET_LOADING, false);
      commit(types.JOURNEY_SET_POSITION, data);
      trySetMusic(commit, data);
    })
    .catch((e) => onJourneyError(commit, e));
};

export const loadStartingPokemons = ({commit, dispatch}) => {
  commit(types.JOURNEY_SET_LOADING, true);

  const staRtingPokemons =
    '&number[]=1' +
    '&number[]=4' +
    '&number[]=7' +
    '&number[]=25' +
    '&number[]=29' +
    '&number[]=32' +
    '&number[]=35' +
    '&number[]=43' +
    '&number[]=46' +
    '&number[]=60' +
    '&number[]=133' +
    '';
  const url = new URL('api/pokemon_types?page=1'+staRtingPokemons, API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.JOURNEY_SET_LOADING, false);
      return data['member'];
    })
    .catch((e) => onJourneyError(commit, e));
};

export const choosePokemon = ({commit, dispatch}, obj) => {
  commit(types.JOURNEY_SET_LOADING, true);
  const url = new URL('api/choose-starting-pokemon', API_ENTRYPOINT);

  return fetch(url, {method: 'POST', body: JSON.stringify(obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.JOURNEY_SET_LOADING, false);
      commit(types.JOURNEY_SET_POSITION, data);
    })
    .catch((e) => onJourneyError(commit, e));
};

export const finishTutorial = ({commit, dispatch}, obj) => {
  commit(types.JOURNEY_SET_LOADING, true);
  const url = new URL('api/finish-tutorial', API_ENTRYPOINT);

  return fetch(url, {method: 'POST', body: JSON.stringify(obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.JOURNEY_SET_LOADING, false);
      commit(types.JOURNEY_SET_POSITION, data);
    })
    .catch((e) => onJourneyError(commit, e));
};

// Bezstavovy "mock" vypocet jednoho kola tutorial fightu (viz
// TutorialFightRoundAction.php) - na rozdil od ostatnich journey akci
// nekomituje JOURNEY_SET_POSITION (odpoved neni Position).
export const tutorialFightRound = ({commit, dispatch}, obj) => {
  commit(types.JOURNEY_SET_LOADING, true);
  const url = new URL('api/tutorial-fight-round', API_ENTRYPOINT);

  return fetch(url, {method: 'POST', body: JSON.stringify(obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.JOURNEY_SET_LOADING, false);
      return data;
    })
    .catch((e) => onJourneyError(commit, e));
};

export const meetPokemon = ({commit, dispatch}, obj) => {
  commit(types.JOURNEY_SET_LOADING, true);
  const url = new URL('api/meet-pokemon', API_ENTRYPOINT);

  return fetch(url, {method: 'POST', body: JSON.stringify(obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.JOURNEY_SET_LOADING, false);
      trySetMusic(commit, data);
      commit(types.JOURNEY_SET_POSITION, data);
    })
    .catch((e) => onJourneyError(commit, e));
};

export const campMeetPokemon = ({commit, dispatch}, obj) => {
  commit(types.JOURNEY_SET_LOADING, true);
  const url = new URL('api/camp-meet-pokemon', API_ENTRYPOINT);

  return fetch(url, {method: 'POST', body: JSON.stringify(obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.JOURNEY_SET_LOADING, false);
      commit(types.JOURNEY_SET_POSITION, data);
      // Camp plne vylecí cely tym (jako Novy den), ale zadna odpoved to
      // neposila zvlast - jen plny refetch.
      dispatch('pokemon/refreshActiveTeam', null, {root: true});
    })
    .catch((e) => onJourneyError(commit, e));
};

export const pokemonFight = ({commit, dispatch, state}, obj) => {
  commit(types.JOURNEY_SET_LOADING, true);
  const url = new URL("api/pokemon-fight", API_ENTRYPOINT);
  const previousPosition = state.position;

  return fetch(url, {method: 'POST', body: JSON.stringify(obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.JOURNEY_SET_LOADING, false);
      trySyncFightingPokemonHp(dispatch, data, previousPosition);

      const isTrainerWinHold = FIGHTING_POSITION_TYPES_FOR_WIN_HOLD.includes(previousPosition.type)
          && TRAINER_WIN_TYPES.includes(data.type)
          && data.type !== previousPosition.type;

      if (isTrainerWinHold) {
        // Drz stary (bojovy) typ, jen preber cerstva fight/trainerFight data
        // z vitezne odpovedi (financi HP, dice-breakdown posledniho kola) -
        // Journey.vue tak dal renderuje BattleScreen miste *Next.vue
        // obrazovky, dokud hrac neklikne na Victory (viz confirmTrainerWin
        // nize, FightButtons.vue). Hudba nove obrazovky se schvalne
        // nenastavuje tady - az po potvrzeni.
        commit(types.JOURNEY_SET_POSITION, {...previousPosition, pokemonFight: data.pokemonFight, trainerFight: data.trainerFight});
        commit(types.JOURNEY_SET_PENDING_TRAINER_WIN, data);
        return;
      }

      trySetMusic(commit, data);
      commit(types.JOURNEY_SET_POSITION, data);
    })
    .catch((e) => onJourneyError(commit, e));
};

export const confirmTrainerWin = ({commit, state}) => {
  const pendingTrainerWin = state.pendingTrainerWin;
  if (!pendingTrainerWin) {
    return;
  }
  trySetMusic(commit, pendingTrainerWin);
  commit(types.JOURNEY_SET_POSITION, pendingTrainerWin);
  commit(types.JOURNEY_SET_PENDING_TRAINER_WIN, null);
};

export const buttonsVolumeSetup = ({commit}, volume) => {
      commit(types.JOURNEY_SET_BUTTON_VOLUME, volume);
};

export const musicVolumeSetup = ({commit}, volume) => {
      commit(types.JOURNEY_SET_MUSIC_VOLUME, volume);
};


function trySetMusic (commit, data) {
  if (data && data['musicTrack']) {
    commit(types.JOURNEY_SET_TRACK, data['musicTrack']);
  }
}

// Promitnuti cerstvych pokeballs/masterballs (z prave prijate position
// odpovedi, napr. po kroku v dungeonu) i do samostatneho trainer.ownTrainer
// slotu - jinak zustava TeamBottomSheet.vue pocitadlo na stare hodnote z
// prihlaseni, protoze dungeon/boj mutuje jen journey.position.trainer. Jde
// pres trainer/patchOwnTrainerBalls "patch" vetev (zadny extra request
// navic) - viz trySyncFightingPokemonHp vyse pro stejny vzor u HP.
function trySyncOwnTrainerBalls (dispatch, data) {
  const trainer = data && data.trainer;
  if (trainer && trainer.pokeballs !== undefined && trainer.masterballs !== undefined) {
    dispatch('trainer/patchOwnTrainerBalls', trainer, {root: true});
  }
}

// Promitnuti cerstveho HP trenerova pokemona (z prave prijate odpovedi
// souboje) i do sdileneho pokemon/items - jinak zustava TeamBottomSheet.vue
// na stare kopii, protoze souboj mutuje jen journey.position. Volat PRED
// commit(JOURNEY_SET_POSITION, data) - previousPosition musi byt jeste stara
// hodnota. Jde pres `pokemon/refreshActiveTeam` "patch" vetev (zadny extra
// request navic).
//
// Kdyz trenerovi behem trenerskeho/league/Mewtwo souboje omdli aktivni
// pokemon (a neni posledni), backend ve stejne odpovedi rovnou nastavi
// trainerPokemon na null (misto hp:0), aby UI ukazalo vyber dalsiho pokemona
// - "hp:0" kolo tedy nikdy nedorazi. Kdyz je fight porad aktivni, ale
// trainerPokemon je null, pozna se to porovnanim s previousPosition a spusti
// se plny refetch (ne rucne sestaveny {id, hp:0} patch - skutecna posmrtna
// hp/endangered hodnota v odpovedi vubec neni, viz Pokemon::getEndangered() na BE).
function trySyncFightingPokemonHp (dispatch, data, previousPosition) {
  const fight = data && data.pokemonFight;
  if (!fight) {
    return;
  }
  const pokemon = fight.trainerPokemon;
  if (pokemon && pokemon.id) {
    dispatch('pokemon/refreshActiveTeam', pokemon, {root: true});
    return;
  }
  const previousPokemon = previousPosition && previousPosition.pokemonFight && previousPosition.pokemonFight.trainerPokemon;
  if (previousPokemon && previousPokemon.id) {
    dispatch('pokemon/refreshActiveTeam', null, {root: true});
  }
}


